module.exports = __webpack_public_path__ + "static/Image_Asset_1-903c19c0c53d376c166fe969eefb50d9.png";